import { render, staticRenderFns } from "./MasterShare.vue?vue&type=template&id=21527bc0&scoped=true&"
import script from "./MasterShare.vue?vue&type=script&lang=js&"
export * from "./MasterShare.vue?vue&type=script&lang=js&"
import style0 from "./MasterShare.vue?vue&type=style&index=0&id=21527bc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21527bc0",
  null
  
)

export default component.exports